import { pharmaciesGroupsTypes } from '../types'

const initialState = {
  items: [],
  isRequesting: false,
  isError: false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case pharmaciesGroupsTypes.GET_PHARMACIES_GROUPS__REQUEST: return {
      ...state,
      isRequesting: true
    }
    case pharmaciesGroupsTypes.GET_PHARMACIES_GROUPS__SUCCESS: return {
      ...state,
      isRequesting: false,
      items: action.payload.items
    }
    default:
      return state
  }
}
